import { IEntity } from '@pf/shared-common';
import {
    ParamViewModel,
    WorkflowGlobalParametersCreateBody,
    WorkflowGlobalParametersEntitySearchRequestParams,
    WorkflowGlobalParameterViewModelRead,
} from '@control-tower/platform-loads';

export type WorkflowGlobalParametersRead =
    WorkflowGlobalParameterViewModelRead & IEntity;
export type WorkflowGlobalParametersCreate = WorkflowGlobalParametersCreateBody;
export type WorkflowGlobalParametersSearchParams =
    WorkflowGlobalParametersEntitySearchRequestParams;

export class WorkflowGlobalParametersDto implements IEntity {
    constructor(data: Partial<WorkflowGlobalParametersDto>) {
        Object.assign(this, data);
        this.name = data.name || 'Default';
    }

    id!: string;
    isDeleted?: boolean;
    createdDate?: string;
    modifiedDate?: string;

    name!: string;
    description?: string;
    parameters?: ParamViewModel[];
}
